import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-erwei",
  "use": "icon-erwei-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"https://www.w3.org/2000/svg\" xmlns:xlink=\"https://www.w3.org/1999/xlink\" id=\"icon-erwei\">\n  <path d=\"M688.814 176.789l158.39 158.39-448.018 448.019-158.39-158.39zM192 832V673.6L350.4 832zM895.2 287.2L736.8 128.8 783.6 82c24-24 63.3-24 87.4 0l71 71c24 24 24 63.3 0 87.4l-46.8 46.8zM128 896h768v64H128zM64 768h64v192H64z\" p-id=\"11026\" />\n  <path d=\"M895.3 768h64v192h-64z\" p-id=\"11027\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/erwei.svg
// module id = +WEy
// module chunks = 12